import * as tvx from "../../lib/tvx-plugin-module.min";
import {
  MSXContentRoot,
  MSXContentItem,
  MSXContentPage,
} from "../../lib/tvx-plugin-module.min";

import {
  res_audio_tracks,
  res_blackColor,
  res_choose_season,
  res_country,
  res_description,
  res_director,
  res_episodes,
  res_imdb_rating,
  res_information,
  res_need_to_sign_in,
  res_no_info,
  res_season,
  res_seasons,
  res_subtitles,
  res_watch_now,
  res_year,
  res_yellowColor,
  res_you_may_also_like,
  SERVER_ADDRESS,
} from "../../static-res";
import {
  base64ToObj,
  callCallback,
  coloredText,
  createContentRequest,
  isLogin,
  validateAccountForProtectedAction,
  stopLoadingShowError,
  STORAGE_PREFIX_ID,
} from "../../utils";
import {
  getMovieInfo,
  getSerialInfo,
  getSerialSeasonEpisodes,
} from "../../api/worker";
import {
  apiEpisode,
  apiMovie,
  apiSerial,
  FictionState,
} from "../../api/api-models";
import {
  getCurrentlyDisplayingItemByIndex,
  getDisplayedItems,
  playerProperties,
  truncateString,
} from "../content-utils";
import {
  createFictionAlsoLikeRow,
  createFictionInfo,
  getFictionState,
  setFictionState,
} from "./fiction";
import { title } from "process";
import { log } from "console";

// Функция для проверки авторизации с валидацией токена
function isUserAuthenticated(): boolean {
  // Сначала проверяем базовый флаг логина
  if (!isLogin()) {
    return false;
  }
  
  // Затем проверяем валидность токена и данных пользователя
  return validateAccountForProtectedAction();
}

export function setSerialSeason(serialId: string, seasonNumber: string) {
  const state = getFictionState(serialId);
  if (state != null) {
    state.episodeNumber = "1";
    state.seasonNumber = seasonNumber;
    state.position = 0;
    setFictionState(serialId, state);
  } else {
    const newState: FictionState = {
      position: undefined,
      duration: undefined,
      audio: undefined,
      sub: undefined,
      seasonNumber: seasonNumber,
      episodeNumber: "1",
    };
    setFictionState(serialId, newState);
  }
}

export function setSerialEpisode(serialId: string, episodeNumber: string) {
  console.log(`setSerialEpisode called: serialId=${serialId}, episodeNumber=${episodeNumber}`);
  const state = getFictionState(serialId);
  if (state != null) {
    console.log(`Updating existing state: old episode=${state.episodeNumber}, new episode=${episodeNumber}`);
    state.episodeNumber = episodeNumber;
    setFictionState(serialId, state);
  } else {
    console.log(`Creating new state with episode=${episodeNumber}`);
    const newState: FictionState = {
      position: undefined,
      duration: undefined,
      audio: undefined,
      sub: undefined,
      seasonNumber: "1",
      episodeNumber: episodeNumber,
    };
    setFictionState(serialId, newState);
  }
}

export function createSerialVideoTitle(
  serialTitle: string,
  seasonNumber: string,
  episodeNumber: string,
  episodeTitle: string
): string {
  return `${serialTitle} - ${episodeTitle} - S${seasonNumber}E${episodeNumber}`;
}

export function createSerialVideoURL(
  serialImdbId: string,
  serialTitle: string,
  currentSeasonNumber: string,
  currentEpisodeNumber: string,
  episodeImdbId: string,
  isContinue: boolean
): string {
  console.log(`Creating video URL: serial=${serialImdbId}, season=${currentSeasonNumber}, episode=${currentEpisodeNumber}`);
  
  // Очищаем и валидируем параметры
  const cleanSerialId = encodeURIComponent(serialImdbId);
  const cleanSeason = encodeURIComponent(currentSeasonNumber);
  const cleanEpisode = encodeURIComponent(currentEpisodeNumber);
  const cleanEpisodeId = encodeURIComponent(episodeImdbId);
  const cleanTitle = encodeURIComponent(serialTitle);
  
  const url = `${SERVER_ADDRESS}hls.html?url=https://scrennnifu.click/serial/${cleanSerialId}/${cleanSeason}/${cleanEpisode}/playlist.m3u8&id=${cleanEpisodeId}&type=serial&s=${cleanSeason}&e=${cleanEpisode}&serial-title=${cleanTitle}&serial-id=${cleanSerialId}&continue=${isContinue}`;
  
  console.log(`Generated clean URL: ${url}`);
  return url;
}
export function createSerialAction(
  serialId: string,
  serialTitle: string,
  currentSeasonNumber: string,
  episode: apiEpisode,
  isContinue: boolean
): string {
  console.log(`Creating action for episode ${episode.position} of serial ${serialId}`);
  console.log(`Episode details: title="${episode.title}", imdbid="${episode.imdbid}"`);
  console.log(`isContinue parameter: ${isContinue}`);
  // Не обновляем состояние здесь - пусть видеоплеер сам обрабатывает выбор эпизода
  // setSerialEpisode(serialId, episode.position.toString());
  
  const videoURL = createSerialVideoURL(
    serialId,
    serialTitle,
    currentSeasonNumber,
    episode.position.toString(),
    episode.imdbid,
    isContinue
  );
  console.log(`Generated video URL: ${videoURL}`);
  
  const fixedImage = episode.portraitImage ? episode.portraitImage.replace("@", "$") : "";
  const action = `video:resolve:request:interaction:video:watch:movie|plugin:${videoURL}|${createSerialVideoTitle(
    serialTitle,
    currentSeasonNumber,
    episode.position.toString(),
    episode.title
  )}|${fixedImage}`;
  
  console.log(`Final action: ${action}`);
  return action;
}

function createSerialHeaderPage(serial: apiSerial): MSXContentPage {
  const page: MSXContentPage = {
    items: [
      {
        id: "serialPoster",
        type: "teaser",
        layout: "0,0,3,4",
        image: serial.portraitImage,
        imageFiller: "cover",
        stampColor: res_blackColor,
        progressColor: res_yellowColor,
      },
    ],
  };

  const maxCharsInLine = 88;
  page.items.push(
    {
      type: "default",
      headline: res_description(),
      text: truncateString(serial.description, maxCharsInLine * 4),
      alignment: "top",
      centration: "text|title",
      layout: "3,0,9,2",
    },
    {
      type: "default",
      headline: res_seasons(),
      text: serial.seasonsCount.toString(),
      alignment: "top",
      centration: "text|title",
      layout: "3,2,9,1",
    },
    {
      type: "default",
      headline: res_episodes(),
      text: serial.episodesCount.toString(),
      alignment: "top",
      centration: "text|title",
      layout: "3,3,9,1",
    }
  );

  const state = getFictionState(serial.imdbid);
  if (state != null) {
    const progress =
      state.position != undefined ? state.position / state.duration : 0;
    const time =
      state.position != undefined
        ? tvx.DateTools.getFormattedDurationStr(
            state.position * 1000,
            "hh:mm:ss"
          )
        : "";
    const episodeAndSeason = `S${state.seasonNumber}E${state.episodeNumber}`;
    page.items[0].stamp = `${episodeAndSeason} ${time}`;
    page.items[0].progress = progress;
  }

  return page;
}

function createSeasonsPanelObject(
  serial: apiSerial,
  currentSeason: string
): tvx.AnyObject {
  const seasons = serial.seasons.flatMap((season) => ({
    label: `${res_season()} ${season.position}: ${res_episodes()}: ${season.episodesCount}`,
    focus: Number.parseInt(currentSeason) == season.position,
    action: `[back|interaction:commit:message:content:serial:seasons:${serial.imdbid}:${season.position}]`,
  }));
  console.log(seasons);

  return {
    cache: false,
    reuse: false,
    headline: res_choose_season(),
    template: {
      enumerate: false,
      type: "control",
      layout: "0,0,8,1",
    },
    items: seasons,
  };
}

async function createSeasonsPages(
  serial: apiSerial,
  currentSeasonNumber: string
): Promise<MSXContentPage[]> {
  return await getSerialSeasonEpisodes(serial.imdbid, currentSeasonNumber).then(
    (episodes) => {
      console.log(episodes);

      // Удаляем мертвый код, который мог создавать путаницу с выбором эпизодов
      console.log("Creating episodes pages for season:", currentSeasonNumber);
      console.log("Total episodes:", episodes.length);

      const pages: MSXContentPage[] = [];
      const seasonPageButton: MSXContentPage = {
        headline: res_choose_season(),
        items: [
          {
            id: "serial-seasons-btn",
            type: "teaser",
            title: coloredText(
              res_blackColor,
              `${res_season()} ${currentSeasonNumber}`
            ),
            layout: "0,0,6,1",
            centration: "title",
            color: res_yellowColor,
            alignment: "center",
            action: "panel:data",
            data: createSeasonsPanelObject(serial, currentSeasonNumber),
          },
        ],
      };
      pages.push(seasonPageButton);
      for (let i = 0; i < episodes.length; i += 3) {
        const page: MSXContentPage = {
          headline: `${res_season()} ${currentSeasonNumber} | ${res_episodes()} ${i + 1}-${
            Math.min(i + 3, episodes.length) == episodes.length ? "LAST" : i + 3
          }`,
          items: [],
        };
        const rowEpisodes = episodes.slice(i, i + 3);
        rowEpisodes.forEach((episode, index) => {
          const runtime =
            episode.runtime != 0 ? `${Math.ceil(episode.runtime / 60)} m` : "";
          const poster: MSXContentItem = {
            id: `episode-${serial.imdbid}-s${currentSeasonNumber}-e${episode.position}-${Date.now()}`,
            type: "default",
            image: episode.portraitImage || "",
            imageFiller: "cover",
            layout: `${index * 4},0,4,2`,
            titleFooter: runtime,
            alignment: "right",
            action: isUserAuthenticated()
              ? createSerialAction(
                  serial.imdbid,
                  serial.title,
                  currentSeasonNumber,
                  episode,
                  false  // Изменяем на false, чтобы не использовать сохраненное состояние
                )
              : `info:${res_need_to_sign_in()}`,
          };
          const info: MSXContentItem = {
            type: "default",
            headline: `${i + index + 1}. ${episode.title.toUpperCase()}`,
            text: episode.description,
            layout: `${index * 4}, 2,4,2`,
          };
          page.items.push(poster);
          page.items.push(info);
        });
        pages.push(page);
      }
      console.log(pages);

      return pages;
    }
  );
}

export function createSerialRoot(
  serialId: string,
  callback: (data: any) => void
): void {
  getSerialInfo(serialId).then((serial) => {
    if (serial != null) {
      const serialRoot: MSXContentRoot = {
        name: `${serial.title} - ${serial.releaseYear}`.toUpperCase(),
        headline: `${serial.title} - ${serial.releaseYear}`.toUpperCase(),
        flag: "serial",
        important: true,
        background: `${serial.portraitImage}#msx-keep-ratio`,
        type: "list",
        cache: false,  // Отключаем кэширование для сериалов
        restore: false, // Отключаем восстановление состояния
        reuse: false,   // Отключаем переиспользование
        pages: [createSerialHeaderPage(serial)],
      };

      const serialState = getFictionState(serial.imdbid);
      const seasonNumber =
        serialState == null
          ? "1"
          : serialState.seasonNumber == undefined
          ? "1"
          : serialState.seasonNumber;
      createSeasonsPages(serial, seasonNumber).then((pages) => {
        pages.forEach((page) => {
          serialRoot.pages.push(page);
        });
        createFictionAlsoLikeRow("serial", serialId).then((page) => {
          serialRoot.pages.push(page);
          serialRoot.pages.push(createFictionInfo(serial));
          callCallback(serialRoot, callback);
        });
      });
    } else {
      stopLoadingShowError(null, callback);
    }
  });
}
